<template>
  <div>

    <div class="d-block d-sm-block d-md-none">
      <BannerTopMobile
        :image="`${url_banners_mobile}/images/mobile/banner2.jpg`"
        :show_search="true"
      ></BannerTopMobile>
    </div>

    <v-container class="mt-5" :style="`${!products.length ? 'margin-bottom: 50%' : ''}`">
      <v-row>
        <v-col class="text-center">
          <h1 class="color-blue font-backward">{{ category }}</h1>
        </v-col>
      </v-row>

      <div v-if="category == 'Todos'" class="row pa-sm-10 d-block d-sm-block d-md-none">
        <div class="text-center col color-blue font-general-r">
          <HomeText/>
        </div>
      </div>

      <v-row>
        <v-col class="text-center">

          <!--escritorios-->
          <div class="d-none d-sm-none d-md-block">
            <v-row :key="products.length" v-if="products.length">
              <v-col
                cols="12"
                xl="4"
                lg="4"
                md="6"
                sm="12"
                v-for="(item, index) in products"
                :key="index"
                class="mb-10"
              >
                <ItemSlideFlavor
                  @addCart="openSnack"
                  :active="false"
                  :item="item"
                />
              </v-col>
            </v-row>
          </div>

          <!--moviles-->
          <div class="d-block d-sm-block d-md-none pb-5" v-if="products.length">
            <v-sheet
              class="mx-auto"
              elevation="0"
              width="400"
              color="light"
            >
              <v-slide-group
                v-model="slide"
                class="pa-4"
                center-active
              >
                <v-slide-item
                  v-for="(item, index) in products"
                  :key="index"
                  class="mr-7"
                >
                  <ItemFlavorMobile
                    @addCart="openSnack"
                    :active="false"
                    :item="item"
                  />
                </v-slide-item>
              </v-slide-group>
            </v-sheet>
          </div>

          <div v-else class="row mt-50 bg-nv-light">
            <div class="col">
              <p class="h3 color-blue font-general-r">No hay sabores que mostrar</p>
            </div>
          </div>

        </v-col>
      </v-row>
    </v-container>

    <v-overlay :value="overlay">
      <img class="nv-loading" src="@/assets/store/nievedeolla.gif" alt="">
    </v-overlay>

    <SnackbarCart ref="snackbarCart"/>

  </div>
</template>

<script>
import HomeService from '@/services/home.service'
import { mapState } from 'vuex'
import ItemSlideFlavor from '@/components/store/ItemSlideFlavor'
import ItemFlavorMobile from '@/components/store/mobile/ItemFlavorMobile'
import HomeText from '@/components/store/HomeText'

export default {
  components: { ItemSlideFlavor, ItemFlavorMobile, HomeText },
  data() {
    return {
      slide: null,
      url_banners_mobile: process.env.VUE_APP_URL_FILES,
      overlay: false,
      products: [],
      category: ''
    }
  },
  computed: {
    ...mapState(['data_home_page', 'cart'])
  },
  watch: {
    '$route.params.cat_id': {
      handler() {
        this.getProducts()
      },
      deep: true
    }
  },
  methods: {
    openSnack() {
      this.$refs.snackbarCart.open()
    },
    async getProducts() {
      this.overlay = true
      let slug = this.$route.params.slug
      let cat_id = this.$route.params.cat_id
      const { data:res } = await HomeService.getProducts(cat_id, slug)
      this.products = res
      if (slug != 'todos') {
        this.data_home_page.categories_flavors.forEach(i => {
          if (i.key_ == slug) {
            this.category = i.name
          }
        })
      } else {
        this.category = 'Todos'
      }
      this.overlay = false
    }
  },
  mounted() {
    window.$('.carousel').carousel();
  },
  created() {
    this.getProducts()
  }
}
</script>
